<template>
  <div>
    <div class="topBox">
      <div class="top container">
        <!-- 移动端导航 -->
        <MobileNav></MobileNav>

        <!-- PC端导航 -->
        <div class="pc-nav">
          <Logo></Logo>
          <div class="title">
            <div class="navLink">
              <router-link to="/home">首页</router-link>
              <router-link to="/apiMarget">API列表</router-link>
              <router-link to="/resourceDownload">图书资源包下载</router-link>
              <router-link class="book-match-link" to="/bookMatch">
                批量匹配<span class="new-badge">新</span>
              </router-link>
            </div>
            <div class="btn" v-if="!userInfo.token">
              <button class="login" @click="login">登录</button>
              <button class="register" @click="reg">注册</button>
            </div>
            <div
              class="user"
              v-else
              @mouseenter="logoutMyapiFlag = true"
              @mouseleave="logoutMyapiFlag = false"
            >
              <button class="userCenter" @click="$router.push('/userLayout')">
                个人中心
              </button>
              <div class="logout-myapi" v-show="logoutMyapiFlag">
                <div class="logout" @click="logout">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import MobileNav from '@/components/MobileNav.vue'
import { mapState } from 'vuex'
import { logout } from '@/api/common'
export default {
  name: 'LayoutIndex',
  data () {
    return {
      logoutMyapiFlag: false
    }
  },
  methods: {
    login () {
      this.$router.push('/login')
    },
    reg () {
      this.$router.push('/reg')
    },
    async logout () {
      await logout()
      this.$store.commit('removeUserInfo')
      this.$router.push('/').catch((err) => {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    }
  },
  components: { Logo, MobileNav },
  computed: {
    ...mapState(['logoUrl', 'userInfo'])
  }
}
</script>

<style lang="less" scoped>
.topBox {
  border-bottom: 1px solid #e7e1e1;
}
.top {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pc-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  .title {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.user {
  position: relative;
  .userCenter {
    height: 38px;
    padding: 0 18px;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    border: none;
    color: #fff;
    border-radius: 19px;
    cursor: pointer;
  }
  .logout-myapi {
    position: absolute;
    top: 39px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    background-color: #fff;
    font-size: 13px;
    border-radius: 6px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid #ebeef5;
    overflow: hidden;
    z-index: 100;
    .logout {
      padding: 8px 12px;
      color: #606266;
      text-align: center;
      transition: all 0.2s;
      cursor: pointer;
      &:hover {
        background-color: #f56c6c;
        color: #fff;
      }
    }
  }
}
.navLink {
  color: #333;
  font-size: 17px;
  width: 610px;
  display: flex;
  justify-content: space-around;
}
.book-match-link {
  position: relative;
  white-space: nowrap;
}
.new-badge {
  position: absolute;
  top: -15px;
  right: -20px;
  min-width: 18px;
  height: 18px;
  padding: 0 3px;
  border-radius: 9px 9px 9px 2px;
  color: #fff;
  background: linear-gradient(135deg, #ff3b30, #ff7a00);
  box-shadow: 0 3px 8px rgba(255, 59, 48, .35);
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}
.btn {
  width: 160px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .login {
    height: 38px;
    padding: 0 18px;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    border: none;
    color: #fff;
    border-radius: 19px;
    cursor: pointer;
  }
  .register {
    height: 38px;
    padding: 0 18px;
    background-color: #f3eeee;
    border: none;
    color: #5f5f5f;
    border-radius: 19px;
    border-color: #d2d2d2;
    cursor: pointer;
  }
}
.router-link-active {
  color: orange;
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .top {
    padding: 0 12px;
  }

  .pc-nav {
    display: none;
  }

  :deep(.mobile-nav) {
    display: block;
  }

  :deep(.logo) {
    width: 100px;
    height: 38px;
  }
}
</style>
<style lang="less" scoped>
.pc-nav .title { width: auto; flex: 1; min-width: 0; gap: 16px; }
.navLink { width: auto; flex: 1; gap: 18px; font-size: 15px; }
.btn { flex-shrink: 0; }
.user .userCenter, .btn .login { background: #2676d9; border-radius: 6px; }
.btn .register { border-radius: 6px; }
.router-link-active { color: #2676d9; }
@media (min-width: 769px) and (max-width: 1000px) {
  .navLink { gap: 10px; font-size: 13px; }
  .btn { width: 130px; }
}
</style>
